import loadable from '@loadable/component'
import { Route, Switch } from 'react-router'

import AuthRoute from 'components/App/Routes/AuthRoute'
import HttpStatus from 'components/Common/HttpStatus'
import Error404PageWithOffers from 'components/Pages/Error404PageWithOffers/Error404PageWithOffers'

const CheckoutPage = loadable(() => import(/* webpackChunkName: "CheckoutPage" */ 'checkout/Pages/CheckoutPage'))

function Routes() {
  return (
    <Switch>
      <AuthRoute
        exact
        showPopup
        path="/:regionCode/checkout/:cartId/:step(cruise-cabin-type|cruise-cabin-category|cruise-cabin-location|cruise-cabin-package)/:cabinId"
        component={CheckoutPage}
      />
      <AuthRoute
        exact
        showPopup
        path="/:regionCode/checkout/:step?"
        component={CheckoutPage}
      />
      <AuthRoute
        exact
        showPopup
        path="/:regionCode/checkout/:cartId/:step?"
        component={CheckoutPage}
      />
      <Route>
        <HttpStatus code={404}>
          <Error404PageWithOffers />
        </HttpStatus>
      </Route>
    </Switch>
  )
}

export default Routes
